import React, { Component } from 'react'
import api from "../../config/api";
import { connect } from 'react-redux'
import {
  debitsComp,
  debitsSelectedComp,
  debitsSelectedIDsComp,
  openSnackComp,
} from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography, Box } from '@material-ui/core';
import ButtonBack from '../../components/ButtonBack';
import InputAccountBank from '../../components/InputAccountBank';
import CheckboxDefault from '../../components/CheckboxDefault';
import ButtonTypeName from '../../components/ButtonTypeName';
import Snackbar from '../../components/Snackbar';
import Constants from '../../helper/resources/Constants';
import iconAddLogo from '../../assets/img/addImage-icon.png';
import Swal from 'sweetalert2';
import { ValidateImageUpload } from '../../helper/validateImageUpload';
import { isObjectNullOrEmpty } from '../../helper/utils';

const styles = () => ({
  container: {
    padding: '0px 30px 20px 30px',
    marginTop: '130px'
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    position: 'relative',
    margin: '25px 0',
  },
  buttonBack: {
    position: 'absolute',
    top: 5,
    left: 0,
  },
  box: {
    background: '#fff',
  },
  uploadImageTitle: {
    fontSize: 15,
    paddingBottom: 15,
    color: '#0000008a',
  },
  labelInputFile: {
    cursor: 'pointer',
    paddingRight: 10,
    fontSize: 18,
  },
  btnUploadFile: {
    cursor: 'pointer',
    background: '#1874b9',
    color: '#fff',
    border: 'none',
    padding: 10,
    borderRadius: 5,
  },
  menuGroup: {
    display: 'flex',
    width: '100%',
    padding: '20px 0px 0px 0px',
  },
  menuIcon: {
    width: 30,
    marginRight: 7
  },
  linkGroup: {
    textDecoration: 'none',
  },
  button: {
    color: 'rgb(24, 116, 185)',
    fontSize: 17,
    background: 'none',
    border: 'none',
    boxShadow: 'none',
  },
  loadingDiv: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  divAddImageIcon: {
    display: 'flex',
    margin: 'auto'
  },
  iconAddImg: {
    width: '50px',
    height: '50px',
    cursor: 'pointer',
  },
})

export class EditBanks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listBanks: [],
      bankObject: '',
      codigoBanco: '',
      nomeBanco: '',
      permiteDAM: false,
      permiteOnline: false,
      permiteDebitoAutomatico: false,
      permiteCadastramentoMisto: false,
      exigeConfirmacao: false,
      selectedFile: null,
      imagePreviewUrl: null,
      message: '',
      readOnly: false,
    }
  }

  componentWillMount() {
    this.props.openSnackComp(false)
    this.props.debitsComp([])
    this.props.debitsSelectedComp([])
    this.props.debitsSelectedIDsComp([])

    if (this.props.location.state !== undefined && this.props.location.state.readOnly) {
      this.setState({
        readOnly: this.props.location.state.readOnly,
        bankObject: this.props.location.state.selectedBank,
      })
    }
  }

  componentDidMount() {
    const { bankObject } = this.state;
    if (bankObject !== null && bankObject !== undefined && bankObject !== '') {
      this.setState({
        codigoBanco: bankObject.CodigoBanco,
        nomeBanco: bankObject.Descricao,
        permiteDAM: bankObject.PermiteDAM,
        permiteOnline: bankObject.PermiteOnline,
        permiteDebitoAutomatico: bankObject.PermiteDebitoAutomatico,
        permiteCadastramentoMisto: bankObject.PermiteCadastramentoMisto,
        exigeConfirmacao: bankObject.ExigeConfirmacao,
        imagePreviewUrl: 'data:image/png;base64,' + bankObject.LogoBancoBase64,
        selectedFile: bankObject.LogoBancoBase64
      })
    }
    //TODO: consulta para carregar DropDown
    // let returnBanks = getBanks(4)
    // returnBanks.then(response => {
    //   this.setState({
    //     listBanks: response,
    //   })
    // })
  }

  getBankTyped = (item) => {
    this.setState({
      codigoBanco: item,
    });
  }

  getCheckboxSelected = (name, isChecked) => {
    switch (name) {
      case Constants.LABEL_PERMITE_PGTO_DAM:
        this.setState({
          permiteDAM: isChecked,
        });
        break;
      case Constants.LABEL_PERMITE_PGTO_ONLINE:
        this.setState({
          permiteOnline: isChecked,
        });
        break;
      case Constants.LABEL_PERMITE_DEBITO_AUT:
        this.setState({
          permiteDebitoAutomatico: isChecked,
        });
        break;
      case Constants.LABEL_PERMITE_CAD_MISTO:
        this.setState({
          permiteCadastramentoMisto: isChecked,
        });
        break;
      case Constants.LABEL_EXIGE_CONFIRMACAO:
        this.setState({
          exigeConfirmacao: isChecked,
        });
        break;
      default:
        break;
    }
  }

  fileChangedHandler = event => {
    if (!ValidateImageUpload(event.target.files[0], 1000000)) {
      this.setState({
        message: "O arquivo selecionado possui formato ou tamanho inválido."
      }, () => {
        this.props.openSnackComp(true)
      })
      event.target.value = null
    } else {
      this.setState({
        selectedFile: event.target.files[0]
      })

      let reader = new FileReader();

      reader.onloadend = () => {
        this.setState({
          imagePreviewUrl: reader.result,
          selectedFile: reader.result.split(",")[1]
        });
      }
      reader.readAsDataURL(event.target.files[0])
    }
  }

  handleEditBank = () => {
    this.setState({
      ...this.state,
      readOnly: false
    }, () => {
      window.scrollTo(0, 0)
    })
  }

  handleUpdateBank = async () => {
    try {
      let banco = this.state.readOnly ?
        this.state.bankObject :
        {
          CodigoBanco: this.state.codigoBanco,
        }

      banco.Id = this.state.bankObject.Id
      banco.PermiteDAM = this.state.permiteDAM
      banco.PermiteOnline = this.state.permiteOnline
      banco.PermiteDebitoAutomatico = this.state.permiteDebitoAutomatico
      banco.PermiteCadastramentoMisto = this.state.permiteCadastramentoMisto
      banco.ExigeConfirmacao = this.state.exigeConfirmacao
      banco.LogoBancoBase64 = this.state.selectedFile

      const inserirEditarResponse = await api.post("Bancos/Editar", banco)

      if (inserirEditarResponse.data.Validado) {
        var successMessage = inserirEditarResponse.data.Mensagem || 'Operação realizada com sucesso.'
        this.setState({
          message: successMessage,
        }, () => {
          Swal.fire({
            icon: 'success',
            text: successMessage,
            showClass: {
              popup: 'animated fadeInDown faster'
            },
            hideClass: {
              popup: 'animated fadeOutUp faster'
            },
            onClose: () => {
              this.props.history.push({
                pathname: "/bancos"
              })
            }
          })
        })
      } else {
        var errorMessage = inserirEditarResponse.data.Mensagem || 'Ocorreu um erro na operação.';

        Swal.fire({
          icon: 'error',
          text: errorMessage,
          showClass: {
            popup: 'animated fadeInDown faster'
          },
          hideClass: {
            popup: 'animated fadeOutUp faster'
          }
        })
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: 'Ocorreu um erro na operação.',
        showClass: {
          popup: 'animated fadeInDown faster'
        },
        hideClass: {
          popup: 'animated fadeOutUp faster'
        }
      })
    }
  }

  render() {
    const { classes } = this.props;
    const { readOnly } = this.state;
    const hasImage = !isObjectNullOrEmpty(this.state.selectedFile);

    let $imagePreview = (<div className="previewText image-container"></div>);
    if (this.state.imagePreviewUrl) {
      $imagePreview = (<div className="image-container" ><img src={this.state.imagePreviewUrl} alt="icon" width="200" /> </div>);
    }

    return (
      <div>
        <Snackbar
          message={this.state.message}
        />

        <Grid container className={classes.container}>

          <div className={classes.title}>
            <div className={classes.buttonBack}>
              <ButtonBack link={"/bancos"} />
            </div>
            <Typography variant="h6" color="textSecondary">
              {readOnly ? 'DETALHAR' : 'EDITAR'} <span style={{ 'color': 'rgba(0, 0, 0, 0.61)' }}>BANCO</span>
            </Typography>
          </div>

          <Box width={1} className={classes.box} p={2}>
            <Box width={1} display="flex" pt={2} pb={2}>
              <Box width="25%" display="flex">
                <InputAccountBank
                  inputType={7} size={'all'}
                  getBankTyped={this.getBankTyped}
                  disabled={true}
                  codigoBancoSelecionado={this.state.codigoBanco}
                />
              </Box>
              <Box width="75%" display="flex">
                <InputAccountBank inputType={8} disabled={true} nomeBancoSelecionado={this.state.nomeBanco} />
                {/* <SelectItem
                typeSelect={1}
                getBankCode={this.getBankTyped}
                banks={this.state.listBanks}
                disabled={readOnly}
                // clearAll={this.state.clearAll}
                codigoBancoSelecionado={this.state.codigoBanco}
              /> */}
              </Box>
            </Box>

            <Box width={1} display="flex" flexDirection="column" pt={2} pb={2}>
              <Box width={1} display="flex">
                <Box width="33%" pb={2}>
                  <CheckboxDefault
                    checkboxName={Constants.LABEL_PERMITE_PGTO_DAM}
                    color={'#0000008a'}
                    getCheckboxSelected={this.getCheckboxSelected}
                    checked={this.state.permiteDAM}
                    disabled={readOnly}
                  />
                </Box>
                <Box width="33%" pb={2}>
                  <CheckboxDefault
                    checkboxName={Constants.LABEL_PERMITE_PGTO_ONLINE}
                    color={'#0000008a'}
                    getCheckboxSelected={this.getCheckboxSelected}
                    checked={this.state.permiteOnline}
                    disabled={readOnly}
                  />
                </Box>
                <Box width="33%" pb={2}>
                  <CheckboxDefault
                    checkboxName={Constants.LABEL_PERMITE_CAD_MISTO}
                    color={'#0000008a'}
                    getCheckboxSelected={this.getCheckboxSelected}
                    checked={this.state.permiteCadastramentoMisto}
                    disabled={readOnly}
                  />
                </Box>
              </Box>

              <Box width={1} display="flex">
                <Box width="33%" pb={2}>
                  <CheckboxDefault
                    checkboxName={Constants.LABEL_PERMITE_DEBITO_AUT}
                    color={'#0000008a'}
                    getCheckboxSelected={this.getCheckboxSelected}
                    checked={this.state.permiteDebitoAutomatico}
                    disabled={readOnly}
                  />
                </Box>

                <Box width="33%" pb={2}>
                  <CheckboxDefault
                    checkboxName={Constants.LABEL_EXIGE_CONFIRMACAO}
                    color={'#0000008a'}
                    getCheckboxSelected={this.getCheckboxSelected}
                    checked={this.state.exigeConfirmacao}
                    disabled={readOnly}
                  />
                </Box>
              </Box>
            </Box>

            <Box width={1} pt={2} pb={2}>
              <Box width={1}>
                <span className={classes.uploadImageTitle}>LOGO DO BANCO (A IMAGEM SELECIONADA DEVE POSSUIR NO MÁXIMO 1MB)</span>
              </Box>


              <Box width={1} mt={2} mr={2} ml={0}>
                <input
                  type="file"
                  id="files"
                  style={{ display: 'none' }}
                  accept="image/x-png,image/jpg,image/jpeg"
                  onChange={this.fileChangedHandler}
                />
                {!readOnly && <div className={classes.divAddImageIcon}>
                  <label title="Clique para adicionar uma imagem."
                    htmlFor="files">
                    {hasImage && <span className={classes.iconAddImg}>{$imagePreview}</span>}
                    {!hasImage && <img src={iconAddLogo} alt="" className={classes.iconAddImg} />}
                  </label>
                </div>}

                {readOnly && hasImage && $imagePreview}
              </Box>
            </Box>
          </Box>

          {readOnly &&
            <Box width={1} display="flex" justifyContent="flex-end" mt={3} mb={3} onClick={this.handleEditBank}>
              <ButtonTypeName typeButton={14} />
            </Box>}

          {!readOnly &&
            <Box width={1} display="flex" justifyContent="flex-end" mt={3} mb={3} onClick={this.handleUpdateBank}>
              <ButtonTypeName typeButton={13} />
            </Box>}          
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  openSnackValue: store.cardDebitState.openSnackValue,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    debitsComp,
    debitsSelectedComp,
    debitsSelectedIDsComp,
    openSnackComp,
  }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditBanks)
);
